<script setup lang="ts">
import Customer from "@/customer/interfaces/Customer";
import {Dialog, DialogTrigger} from "@/core/components/ui/dialog";
import {computed} from "vue";
import CustomerCertificationNotificationModalContent
    from "@/customer-certification/components/certification-modal/CustomerCertificationNotificationModalContent.vue";
import PreCertificationDialogContent
    from "@/customer-certification/components/pre-certification-dialog/PreCertificationDialogContent.vue";

const props = defineProps<{
    customer: Customer
    loadingCustomer?: boolean;
    programId?: number;
    surveyId?: number;
    slugs?: string[];
    feature?: string;
    onCertified?: () => void;
}>();

defineEmits<{
    (e: 'sent'): void;
}>();

const open = defineModel<boolean>("open", {default: false});
const uncertified = computed(() => {
    return props.customer.status === 'none';
});
</script>

<template>
  <Dialog v-model:open="open">
    <DialogTrigger as-child>
      <slot />
    </DialogTrigger>
    <PreCertificationDialogContent
      v-if="uncertified"
      :customer="customer"
      :on-certified="onCertified"
    />
    <CustomerCertificationNotificationModalContent
      v-else
      :key="(new Date()).getTime()"
      :customer="customer"
      :feature="feature"
      :survey-id="surveyId"
      :slugs="slugs"
      :program-id="programId"
      @sent="$emit('sent'); open = false"
    />
  </Dialog>
</template>

<style scoped>

</style>
